export default {
    isAuthenticated: state => !!state.token,
    authToken: state => state.token,
    authStatus: state => state.authStatus,
    authError: state => state.authError,
    loginInfo: state => state.loginInfor,
    packageFilter: state => state.packageFilter,

}